import { Children, ReactNode, RefObject } from 'react';

import { ActionBarMui, FilterBarMui } from '@spotify/confidence-core-react';

import { FiltersProvider } from '../Wrapper';
import { WrapperEntry } from '../Wrapper/composition';

type UseActionBarMuiArgs = {
  wrapperElements: WrapperEntry[];
  actionBar: ReactNode;
  actionBarRef: RefObject<HTMLDivElement | null>;
  actionBarTopOffset: number;
};

export const useActionBarMui = ({
  wrapperElements,
  actionBar,
  actionBarRef,
  actionBarTopOffset,
}: UseActionBarMuiArgs): ReactNode => {
  const hasFiltersProvider = wrapperElements.some(
    entry => entry.element.type === FiltersProvider,
  );

  if (!actionBar && !hasFiltersProvider) return null;

  const userActions = Children.toArray(actionBar);
  const filterBarHasNoSiblings = hasFiltersProvider && userActions.length === 0;

  const actionBarChildren = hasFiltersProvider
    ? [
        <FilterBarMui key="auto-filter-bar" />,
        ...userActions,
        ...(filterBarHasNoSiblings
          ? [<span key="end-anchor" aria-hidden />]
          : []),
      ]
    : actionBar;

  return (
    <ActionBarMui ref={actionBarRef} topOffset={actionBarTopOffset}>
      {actionBarChildren}
    </ActionBarMui>
  );
};
